import { render, staticRenderFns } from "./AtePlatTester.vue?vue&type=template&id=d1673978"
import script from "./AtePlatTester.vue?vue&type=script&lang=js"
export * from "./AtePlatTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports